import React from "react";
import Footer from "../components/Footer";
import InteviewScheduleNavbar from "../components/inteviewSchedule/InteviewScheduleNavbar";
import InterviewScheduleMain from "../components/inteviewSchedule/InterviewScheduleMain";

function InterviewSchedule() {
  return (
    <div className="login-landing-page min-h-screen bg-primaryBg text-primaryWhite px-5 lg:px-8 py-2 flex flex-col justify-between items-center">
      <InteviewScheduleNavbar />
      <div className=" w-full">

      <InterviewScheduleMain />
      </div>
      <Footer />
    </div>
  );
}

export default InterviewSchedule;
